import { render, staticRenderFns } from "./BreakageReport.vue?vue&type=template&id=23c24e96&scoped=true&"
import script from "./BreakageReport.vue?vue&type=script&lang=js&"
export * from "./BreakageReport.vue?vue&type=script&lang=js&"
import style0 from "./BreakageReport.vue?vue&type=style&index=0&id=23c24e96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c24e96",
  null
  
)

export default component.exports